import { FC } from "react";

import { useTranslation } from "react-i18next";

import { useCartDocument } from "@hooks/useCartDocument";

import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DocumentDetails from "../DocumentDetails";

import { brandColorTokens, brandRadius } from "@constants";

import { IBundledDocumentProperties } from "./BundledDocument.types";

const bundledDocumentStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  p: 2,
  bgcolor: "background.default",
  borderRadius: `${brandRadius.medium}px`,
} as const;

const BundledDocument: FC<IBundledDocumentProperties> = ({ documentId }) => {
  const { t } = useTranslation();
  const { document, isLoading: isDocumentLoading } = useCartDocument(documentId);

  if (isDocumentLoading) {
    return (
      <Box sx={bundledDocumentStyle}>
        <Skeleton variant="text" width={160} />
      </Box>
    );
  }

  if (document == null) {
    return null;
  }

  return (
    <Box sx={bundledDocumentStyle}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <DescriptionOutlinedIcon fontSize="small" sx={{ color: brandColorTokens.icon.subtle }} />
        <Typography variant="body1" fontWeight={500}>
          {t(`global.products.${document.type}`)}
        </Typography>
      </Box>
      <DocumentDetails document={document} />
    </Box>
  );
};

export default BundledDocument;
